<template>
  <div :class="['sidebar bg-main-darker text-white flex flex-col',
                'sidebar-width']">
    <!-- header container for talkatoo logo -->
    <div :class="['heading-container ml-[0.9375rem]  flex', expandSidebar ? 'mr-9' : '']">
      <RouterLink v-if="isLoggedIn" to="/">
        <div class="logo-wrapper mr-4" @click="mobileMenu = false">
          <img
            src="@/assets/images/talkatoo_logo_icon.svg"
            class="logo m-auto"
            aria-label="Admin Portal Home"
            height="52" width="52"
          />
        </div>
        <div v-if="expandSidebar" class="sidebar-expandable-text">
          <div class="flex flex-col justify-between flex-grow w-full text-white">
            <!-- this spells talkatoo in a very specific font -->
            <svg width="120" height="28" viewBox="0 0 120 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M28.4861 0H31.1991V27.1299H28.4861V0Z" fill="white" />
              <path d="M35.2687 0H37.8022V18.627L47.873 7.94046H51.2933L43.566 16.1787L51.5466 27.1299H48.253L41.6025 18.0976L37.8022 22.0017V27.1299H35.2687V0Z" fill="white" />
              <path d="M88.7333 27.1297C87.2632 27.1297 85.9267 26.8619 84.7239 26.3265C83.4877 25.791 82.4186 25.0548 81.5165 24.1512C80.6144 23.2476 79.9127 22.1767 79.4116 20.9384C78.9104 19.7336 78.6765 18.4285 78.6765 17.0229V16.9559C78.6765 15.5838 78.9104 14.2786 79.4116 13.0404C79.9127 11.8022 80.6144 10.7312 81.5165 9.79418C82.4186 8.85713 83.4877 8.12087 84.7239 7.58542C85.9602 7.04996 87.33 6.78223 88.8001 6.78223C90.2702 6.78223 91.6067 7.04996 92.8429 7.58542C94.0791 8.12087 95.1482 8.85713 96.0503 9.76072C96.9524 10.6643 97.7209 11.7352 98.2221 12.9735C98.7232 14.1782 99.0239 15.4834 99.0239 16.889V16.9559C99.0239 18.3281 98.6898 19.6332 98.1887 20.8715C97.6875 22.1097 96.919 23.1806 96.0169 24.1177C95.1148 25.0548 94.0123 25.791 92.776 26.3265C91.5398 26.8619 90.17 27.1297 88.7333 27.1297ZM88.8001 24.5193C89.8693 24.5193 90.8048 24.3185 91.7069 23.9169C92.5756 23.5153 93.344 22.9798 93.9789 22.3105C94.6137 21.6412 95.1482 20.838 95.4824 19.9344C95.8499 19.0308 96.0503 18.0603 96.0503 17.0229V16.9559C96.0503 15.885 95.8165 14.9145 95.4489 14.0109C95.0814 13.1073 94.5468 12.3041 93.912 11.6014C93.2438 10.8986 92.4753 10.3631 91.6067 9.96151C90.738 9.55992 89.769 9.35912 88.7333 9.35912C87.6641 9.35912 86.6952 9.55992 85.8265 9.96151C84.9578 10.3631 84.1894 10.8986 83.588 11.5679C82.9866 12.2372 82.5188 13.0404 82.1513 13.9775C81.7838 14.881 81.6501 15.885 81.6501 16.889V16.9559C81.6501 18.0269 81.8172 18.9974 82.1847 19.901C82.5522 20.8045 83.02 21.6077 83.6882 22.3105C84.323 22.9798 85.0915 23.5153 85.9602 23.9169C86.8289 24.3185 87.7644 24.5193 88.8001 24.5193Z" fill="white" />
              <path d="M109.798 27.1297C108.426 27.1297 107.179 26.8619 106.056 26.3265C104.902 25.791 103.904 25.0548 103.062 24.1512C102.22 23.2476 101.566 22.1767 101.098 20.9384C100.63 19.7336 100.381 18.4285 100.381 17.0229V16.9559C100.381 15.5838 100.63 14.2786 101.098 13.0404C101.566 11.8022 102.22 10.7312 103.062 9.79418C103.904 8.85713 104.902 8.12087 106.056 7.58542C107.21 7.04996 108.488 6.78223 109.86 6.78223C111.233 6.78223 112.48 7.04996 113.634 7.58542C114.788 8.12087 115.785 8.85713 116.627 9.76072C117.469 10.6643 118.155 11.7352 118.623 12.9735C119.091 14.1782 119.372 15.4834 119.372 16.889V16.9559C119.372 18.3281 119.091 19.6332 118.623 20.8715C118.155 22.1097 117.469 23.1806 116.627 24.1177C115.785 25.0548 114.756 25.791 113.603 26.3265C112.418 26.8619 111.17 27.1297 109.798 27.1297ZM109.86 24.5193C110.858 24.5193 111.732 24.3185 112.573 23.9169C113.384 23.5153 114.101 22.9798 114.694 22.3105C115.286 21.6412 115.754 20.838 116.097 19.9344C116.44 19.0308 116.596 18.0603 116.596 17.0229V16.9559C116.596 15.885 116.409 14.9145 116.066 14.0109C115.723 13.1073 115.255 12.3041 114.632 11.6014C114.008 10.8986 113.291 10.3631 112.48 9.96151C111.669 9.55992 110.765 9.35912 109.798 9.35912C108.8 9.35912 107.927 9.55992 107.085 9.96151C106.274 10.3631 105.557 10.8986 104.996 11.5679C104.435 12.2372 103.967 13.0404 103.655 13.9775C103.312 14.881 103.156 15.885 103.156 16.889V16.9559C103.156 18.0269 103.312 18.9974 103.655 19.901C103.998 20.8045 104.466 21.6077 105.058 22.3105C105.651 22.9798 106.368 23.5153 107.179 23.9169C108.021 24.3185 108.894 24.5193 109.86 24.5193Z" fill="white" />
              <path d="M23.7346 9.12101C22.3648 7.68433 20.3261 6.78223 17.714 6.78223C16.5035 6.78223 15.1974 6.84905 14.2099 7.08293L12.7764 9.78924C13.6684 9.52195 15.3886 9.45512 17.3954 9.45512C19.1474 9.45512 20.4854 10.0899 21.441 10.992C22.3967 11.8607 22.8426 13.1638 22.8426 14.9012V15.5026C22.2055 15.2353 21.1862 15.0348 20.3261 14.9012C19.466 14.7675 18.4466 14.6673 17.268 14.6673C16.0894 14.6673 15.0381 14.8009 14.0825 15.0682C13.1268 15.3355 12.2986 15.7364 11.5978 16.271C10.897 16.8056 10.3873 17.4404 10.005 18.2423C9.62278 19.0441 9.49536 19.9462 9.49536 21.0154V21.0822C9.49536 22.0846 9.62278 22.9533 10.005 23.7217C10.3873 24.4902 10.8333 25.0916 11.5022 25.6262C12.1393 26.1273 12.9039 26.5283 13.7321 26.7621C14.5603 26.996 15.4204 27.1297 16.2805 27.1297C17.9051 27.1297 19.243 26.7955 20.3261 26.1273C21.4092 25.4591 22.2692 24.6906 22.9063 23.8219V26.829H25.7733V14.8677C25.7096 12.3953 25.0406 10.4909 23.7346 9.12101ZM22.8426 19.5787C22.8426 20.3472 22.7471 21.0488 22.4285 21.6836C22.11 22.3184 21.7277 22.853 21.1543 23.3208C20.5809 23.7885 19.9438 24.1226 19.2112 24.3899C18.4785 24.6238 17.6821 24.7575 16.822 24.7575C16.2168 24.7575 15.5797 24.6572 15.0381 24.4902C14.4648 24.3231 13.9551 24.0558 13.541 23.7551C13.1268 23.421 12.7446 23.0201 12.4897 22.5523C12.2349 22.0511 12.0438 21.5166 12.0438 20.9152V20.8483C12.0438 19.679 12.5853 18.7434 13.5091 18.0084C14.4648 17.3068 15.8345 16.9392 17.5547 16.9392C18.7015 16.9392 19.689 17.0395 20.5809 17.2065C21.4729 17.3736 22.2374 17.574 22.8745 17.7745V19.5787H22.8426Z" fill="white" />
              <path d="M65.7858 9.12101C64.4161 7.68433 62.3774 6.78223 59.7652 6.78223C58.5547 6.78223 57.2487 6.84905 56.2612 7.08293L54.8277 9.78924C55.7196 9.52195 57.4398 9.45512 59.4467 9.45512C61.1987 9.45512 62.5366 10.0899 63.4923 10.992C64.4479 11.8607 64.8939 13.1638 64.8939 14.9012V15.5026C64.2568 15.2353 63.2374 15.0348 62.3774 14.9012C61.5173 14.7675 60.4979 14.6673 59.3193 14.6673C58.1406 14.6673 57.0894 14.8009 56.1338 15.0682C55.1781 15.3355 54.3499 15.7364 53.6491 16.271C52.9483 16.8056 52.4386 17.4404 52.0563 18.2423C51.6741 19.0441 51.5466 19.9462 51.5466 21.0154V21.0822C51.5466 22.0846 51.6741 22.9533 52.0563 23.7217C52.4386 24.4902 52.8845 25.0916 53.5535 25.6262C54.1906 26.1273 54.9551 26.5283 55.7834 26.7621C56.6116 26.996 57.4717 27.1297 58.3318 27.1297C59.9564 27.1297 61.2943 26.7955 62.3774 26.1273C63.4604 25.4591 64.3205 24.6906 64.9576 23.8219V26.829H67.8246V14.8677C67.7609 12.3953 67.0919 10.4909 65.7858 9.12101ZM64.8939 19.5787C64.8939 20.3472 64.7983 21.0488 64.4798 21.6836C64.1612 22.3184 63.779 22.853 63.2056 23.3208C62.6322 23.7885 61.9951 24.1226 61.2624 24.3899C60.5298 24.6238 59.7334 24.7575 58.8733 24.7575C58.2681 24.7575 57.6309 24.6572 57.0894 24.4902C56.516 24.3231 56.0063 24.0558 55.5922 23.7551C55.1781 23.421 54.7958 23.0201 54.541 22.5523C54.2862 22.0511 54.095 21.5166 54.095 20.9152V20.8483C54.095 19.679 54.6366 18.7434 55.5604 18.0084C56.516 17.3068 57.8858 16.9392 59.606 16.9392C60.7527 16.9392 61.7403 17.0395 62.6322 17.2065C63.5241 17.3736 64.2887 17.574 64.9258 17.7745V19.5787H64.8939Z" fill="white" />
              <path d="M6.86346 24.2783C6.43829 24.379 5.95238 24.4125 5.49684 24.4125C4.61613 24.4125 3.8569 24.1776 3.31025 23.7078C2.76361 23.238 2.42954 22.399 2.42954 21.1909V9.7472H6.95457L8.13897 7.39806H2.42954V1.35742H0V21.5936C0 22.5668 0.0911079 23.4058 0.334062 24.1105C0.577017 24.8488 0.911079 25.4193 1.33625 25.8556C1.79179 26.2919 2.30807 26.6274 2.91545 26.8288C3.52284 27.0302 4.19096 27.1308 4.88946 27.1308C5.52721 27.1308 6.16497 27.0637 6.68125 26.9295C7.10642 26.8288 7.47085 26.661 7.92639 26.4261L6.86346 24.2783Z" fill="white" />
              <path d="M78.545 24.3082C78.5096 24.3082 78.5096 24.3082 78.545 24.3082C78.049 24.409 77.4821 24.4426 76.9506 24.4426C75.9231 24.4426 75.0374 24.2074 74.3996 23.7369C73.7619 23.2665 73.3721 22.4264 73.3721 21.2167V9.75814H78.6513L80.0331 7.40594H73.3721V1.35742H70.5377V21.62C70.5377 22.5944 70.6439 23.4345 70.9274 24.1402C71.2108 24.8458 71.5652 25.4171 72.0966 25.8539C72.6281 26.2908 73.2304 26.6268 73.939 26.8284C74.6476 27.03 75.4271 27.1308 76.242 27.1308C76.9861 27.1308 77.7301 27.0636 78.3324 26.9292C78.8285 26.8284 79.2536 26.6604 79.7851 26.4252L78.545 24.3082Z" fill="white" />
            </svg>
          </div>
        </div>
      </RouterLink>
    </div>

    <div class="sidebar-item">
      <RouterLink id="dashboard-nav" to="/" class="sidebar-group">
        <BaseIcon class="sidebar-icon" text="HM" icon="home" themeName="neutral" themeSuffix="lighter" diameter="1.6" borderWidth="2" />
        <div v-if="expandSidebar" class="sidebar-expandable-text">
          Your Dashboard
        </div>
      </RouterLink>
    </div>

    <div class="sidebar-item">
      <RouterLink id="notes-nav" to="/notes" class="sidebar-group">
        <BaseIcon class="sidebar-icon" text="SN" img="notebook_icon_white.svg" themeName="neutral" themeSuffix="lighter" diameter="1.6" borderWidth="2" />
        <div v-if="expandSidebar" class="sidebar-expandable-text">
          Talkatoo Notes
        </div>
      </RouterLink>
    </div>

    <div v-if="userPerms.user_management || userPerms.billing_management" class="sidebar-item">
      <RouterLink id="admin-dashboard-nav" to="/admin-dashboard" class="sidebar-group">
        <BaseIcon class="sidebar-icon" text="AD" icon="supervisor_account" themeName="neutral" themeSuffix="lighter" diameter="1.6" borderWidth="2" />
        <div v-if="expandSidebar" class="sidebar-expandable-text">
          Admin
        </div>
      </RouterLink>
      <Transition name="admin-sidebar">
        <div v-if="isAdminPage">
          <RouterLink v-if="userPerms.user_management" id="user-management-nav" to="/user-management" class="sidebar-subgroup">
            <i class="material-icons m-auto mx-2 text-2xl no-underline">
              account_circle
            </i>
            <div v-if="expandSidebar" class="sidebar-expandable-text">
              Users
            </div>
          </RouterLink>
          <RouterLink v-if="userPerms.billing_management" id="subscription-nav" to="/subscription" class="sidebar-subgroup">
            <i class="material-icons m-auto mx-2 text-2xl no-underline">
              credit_card
            </i>
            <div v-if="expandSidebar" class="sidebar-expandable-text">
              Subscription
            </div>
          </RouterLink>
          <RouterLink v-if="userPerms.billing_management" id="billing-history-nav" to="/billing-history" class="sidebar-subgroup">
            <i class="material-icons m-auto mx-2 text-2xl no-underline">
              receipt
            </i>
            <div v-if="expandSidebar" class="sidebar-expandable-text">
              Billing History
            </div>
          </RouterLink>
        </div>
      </Transition>
    </div>


    <div class="sidebar-item">
      <RouterLink id="settings-dashboard-nav" to="/settings" class="sidebar-group">
        <BaseIcon class="sidebar-icon" text="ST" icon="settings" themeName="neutral" themeSuffix="lighter" diameter="1.6" borderWidth="2" />
        <div v-if="expandSidebar" class="sidebar-expandable-text">
          Settings
        </div>
      </RouterLink>
    </div>

    <div class="sidebar-item">
      <a class="sidebar-link sidebar-group" href="https://talkatoo.com/downloads/" target="_blank">
        <BaseIcon class="sidebar-icon" text="DL" icon="arrow_downward" themeName="neutral" themeSuffix="lighter" diameter="1.6" borderWidth="2" />
        <div v-if="expandSidebar" class="sidebar-expandable-text">
          Download App
        </div>
      </a>
    </div>
    <!-- spacer -->
    <div class="flex-grow"></div>
    <!-- bottom close side bar button -->


    <button class="h-[3.5625rem] relative flex text-base w-full hover:bg-main-dark transition-colors text-left" @click="toggleSidebar">
      <div class="flex h-full border-t border-main-dark py-4 w-full roboto font-bold">
        <div v-if="expandSidebar" class="px-6 material-icons my-auto">
          west
        </div>
        <div v-else class="px-6 ml-1 material-icons my-auto">
          east
        </div>
        <template v-if="expandSidebar">
          <span class="my-auto overflow-hidden whitespace-nowrap ml-4 font-roboto">
            Close Menu
          </span>
        </template>

      </div>
    </button>
  </div>
</template>

<script>
import BaseIcon from "Components/ui/BaseIcon.vue";

export default {
  name: "SideBar",
  components: { BaseIcon },
  data () {
    return {
      expandSidebar: localStorage.getItem('expandSidebar') === 'false' ? false : true,
      adminRoutes: ["AdminDashboard", "UserManagement", "BillingHistory", "Subscription"]
    };
  },
  mounted () {
    // ADD EXPANDED SIDEBAR CLASS TO HTML
    if (this.expandSidebar) {
      document.documentElement.classList.add("expand-sidebar");
    }
  },
  computed: {
    isAdminPage () {
      return this.adminRoutes.find(x => x == this.$router.currentRoute.value.name);
    },
    isLoggedIn () {
      return this.$store.getters.isLoggedIn;
    },
    userPerms () {
      return this.$store.getters.getUserPerms;
    },
    featureFlags () {
      return this.$store.getters.getFeatureFlags;
    },
    isProvisioning () {
      return this.$store.getters.getSubscriptionState === "provisioning";
    },
    initials () {
      //testing first and lastName for undefined
      let firstName = "";
      let initials = "";
      let storeFirstName = this.$store.getters.getUserProfile.firstName;
      let storeLastName = this.$store.getters.getUserProfile.lastName;
      let storeEmail = this.$store.getters.getUserProfile.email;

      if (storeFirstName) {
        firstName = storeFirstName.trim();
        //setting initials with name sections
        if (firstName.length > 0) {
          initials += firstName[0].toUpperCase();
        }
      }
      let lastName = "";
      if (storeLastName) {
        lastName = storeLastName.trim();
        //setting initials with name sections
        if (lastName.length > 0) {
          initials += lastName[0].toUpperCase();
        }
      }
      let email = "";
      if (initials === "") {
        if (storeEmail) {
          email = storeEmail.trim();
          if (email.length > 0) {
            initials += email[0].toUpperCase();
          }
        }
      }
      return initials;
    },
  },
  methods: {
    direct (route) {
      if (!this.selectedRoute(route))
        this.$router.push(route).catch(err => { console.log(err); });
    },
    selectedRoute (route) {
      return this.$route.path === route;
    },
    toggleSidebar () {
      this.expandSidebar = !this.expandSidebar;
      document.documentElement.classList.toggle("expand-sidebar");
      localStorage.setItem('expandSidebar', this.expandSidebar);
    },

  }
};
</script>

<style scoped>
.logo-wrapper {
  @apply h-auto;
}

/* using vars here for the sake of the header matching the size */
.heading-container {
  margin-top: var(--logo-mt);
  margin-bottom: var(--logo-mb);
}

.logo {
  min-height: var(--logo-h);
  min-width: var(--logo-h);
}

.sidebar {
  @apply text-white;
  @apply bg-main-darker;
  @apply sticky;
  height: 100vh;
  top: 0;
  /* transitioning on both min and width for best expanded look and better animation */
  transition-property: width, min-width;
  transition-duration: 0.15s;

}

.sidebar a {
  /* @apply px-2; */
  @apply no-underline;
}

.sidebar-width {
  min-width: 5.25rem;
  width: 5.25rem;
}

html.expand-sidebar .sidebar-width {
  min-width: var(--sidebar-w);
  width: var(--sidebar-w);
}


.sidebar-heading {
  font-size: 1.25rem;
}

.sidebar-list {
  @apply py-1;
  @apply pl-2;
}

.sidebar-group,
.sidebar-subgroup {
  @apply flex;
  @apply cursor-pointer;
  @apply pl-5;
  @apply py-4;
  @apply text-white;
}

.sidebar-subgroup {
  @apply text-main-lighter;
  @apply font-semibold;
}

.sidebar-subgroup>i {
  @apply text-main-light;
  @apply no-underline;
}

.sidebar-group:hover,
.sidebar-group.router-link-active {
  @apply bg-main-dark;
  @apply transition-colors;
}

.sidebar-subgroup:hover {
  @apply text-main-darker;
}

.sidebar-subgroup:hover,
.sidebar-subgroup.router-link-active {
  transition: color 0.1s ease-in;
  @apply bg-main-dark;
  @apply text-white;
}

.sidebar-subgroup.router-link-active>i {
  transition: color 0.1s ease-in;
  @apply text-white;
}

.sidebar-expandable-text {
  @apply pl-2;
  @apply overflow-hidden;
  @apply whitespace-nowrap;
}

.sidebar-icon {
  @apply my-auto;
  min-width: 1.6rem;
}

.sidebar-link {
  outline: none;
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.25rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  @apply font-bold;
  @apply pl-5;
  @apply m-auto;
  @apply mx-0;
}

.admin-sidebar-enter-active,
.admin-sidebar-leave-active {
  transition: height 0.15s ease;
  height: 224px;
  overflow-y: hidden;
}

.admin-sidebar-enter-from,
.admin-sidebar-leave-to {
  transition: height 0.15s ease;
  height: 0;
  overflow-y: hidden;
}
</style>
